import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/translation.json';
import de from './locales/de/translation.json';
import es from './locales/es/translation.json';

// ADD THESE DEBUG LINES
//console.log("EN translation keys:", Object.keys(en));
//console.log("ferienpark_hahnenklee in EN:", en.ferienpark_hahnenklee);
//console.log("All ferienpark keys in EN:", Object.keys(en).filter(key => key.includes('ferienpark')));

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    es: { translation: es },
  },
  lng: 'en', // Default language
  fallbackLng: 'en', // Fallback language
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;